/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "564983d27e65bea8567dd690cd8bf48f98360852";
